module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "SOM"
  }, [_c('h1', {
    staticClass: "SOM_titre"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("List of Illustrations")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre3"
    }
  }, [_vm._v("Key to Panels")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6#niv1-007"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1"
    }
  }, [_vm._v("1 What Is the Pentateuch? Basic Features")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-008"
    }
  }, [_vm._v("Name")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-009"
    }
  }, [_vm._v("Genre")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-010"
    }
  }, [_vm._v("Biography of Moses")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-011"
    }
  }, [_vm._v("National History")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-011a"
    }
  }, [_c('i', [_vm._v("Torah")]), _vm._v(" or Law")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-012"
    }
  }, [_vm._v("Why Five Books?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-013"
    }
  }, [_vm._v("When Did the Pentateuch Become Part of the Bible?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-014"
    }
  }, [_vm._v("Further Reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2"
    }
  }, [_vm._v("2 Genesis 1—11")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#niv1-015"
    }
  }, [_vm._v("Ancient Near Eastern Parallels to Genesis 1—11")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#niv1-018"
    }
  }, [_vm._v("Genesis’ Transformation of Oriental Origin Stories")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#niv1-020"
    }
  }, [_vm._v("The Organization of Genesis 1—11")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#niv1-030"
    }
  }, [_vm._v("The New Testament Use of Genesis 1—11")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#niv1-031"
    }
  }, [_vm._v("Further Reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Genesis 12—50")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Genre of Genesis 12—50")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11: 27—25:11: The Story of Abraham")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25:12—18: Genealogy of Ishmael")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25:19—35:29: The Story of Jacob and Esau")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36:1—37:1: Genealogy of Esau")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37:2—50:26: The Story of Joseph and His Brothers")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-046",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The New Testament Use of Genesis 12—50")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further Reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Exodus")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-049",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Slavery in Egypt and Liberation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-053",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Law-giving")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-056",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Tabernacle")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-058",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The New Testament and the Book of Exodus")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-059",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further Reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Leviticus")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-060",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-061",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Problems of Reading Leviticus")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-046",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Visualization")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Significance")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Interpretation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1:1—7:38: Laws on Sacrifice")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-065",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8:1—10:20: Institution of the Priesthood")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-066",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11:1—16:34: Uncleanness and Its Treatment")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-069",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17:1—27:34: Prescriptions for Practical Holiness")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-071",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The New Testament and Leviticus")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-072",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further Reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Numbers")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv1-073",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv1-075",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Contents of Numbers")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv1-087",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Numbers and the New Testament")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv1-089",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further Reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Deuteronomy")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-090",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-098",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deuteronomy and the New Testament")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-099",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further Reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Theme of the Pentateuch")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv1-100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Martin Noth on the Themes of the Pentateuch")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv1-102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gerhard von Rad and the Pentateuch")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv1-103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("David Clines on the Theme of the Pentateuch")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv1-105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reassessment")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv1-106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further Reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Composition of the Pentateuch")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv1-107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Traditional Ascription of the Pentateuch to Moses")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv1-109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Documentary Hypothesis")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv1-111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Identification of the Sources")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv1-112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twentieth-century Adjustments to the Documentary Hypothesis")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv1-113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Collapse of the Consensus since 1975")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv1-114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Trend towards Unitary Readings")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv1-117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dating of the Sources")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv1-118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further Reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Rhetoric of the Pentateuch")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#niv1-119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Guarded Optimism - a Twelfth-century Setting")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#niv1-120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Celebration and Protest - a Tenth-century Setting")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#niv1-121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reassurance to the Dispirited - a Seventh-century setting")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#niv1-122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hope in Difficult Times - A Fifth-century Setting")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#niv1-124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further Reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 Epilogue")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/ident11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Books in this Series")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/ident13#copy1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 63
// module chunks = 0